{{ params.value  | numberLocale:params.colDef.cellRendererParams | lT }}
